import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Subject } from "rxjs";
import { IFormKey } from "src/app/modules/shared/models/forms";
import { DATE_FORMAT, DATE_FORMAT_SLASH } from "src/app/modules/shared/models/policy.model";
import { CommonUtils } from "src/app/utils/CommonUtils";
import { PolicyService } from "../../../policy/policy.service";
import { applicant_keys_PF, DOC_EXPIRED_MESSAGE, IAnagrafica, IDettaglioAnagrafico, ndg_variation_form_keys } from "./ndg-variation.constants";
import moment = require("moment");
import { DETTAGLIO_ANAGRAFICO_KEY } from "src/app/modules/shared/models/operation.model";

@Component({
    selector: 'app-ndg-variation',
    templateUrl: './ndg-variation.component.html',
    styleUrl: './ndg-variation.component.scss',
})
export class NdgVariationComponent implements OnInit, OnDestroy{

    @Input() form: FormGroup;
    @Input() ndgVariationList: IAnagrafica[];
    @Input() selectedSubject: IDettaglioAnagrafico = null;
    formKeys: IFormKey[] = CommonUtils.assign(ndg_variation_form_keys);
    showEmptyListMessage: boolean = false;
    dettaglioAnagraficoKey: string = DETTAGLIO_ANAGRAFICO_KEY;
    @Output() onSubjectSelection = new EventEmitter<IDettaglioAnagrafico>();
    destroy$ = new Subject();

    constructor(
        private _policyService: PolicyService,
    ) { }

    ngOnInit(): void {
        if (!this.ndgVariationList) {
            this.showEmptyListMessage = true;
        }
        this.form.valueChanges.subscribe(change => {
            const ndg = change?.ndg;
            this.selectedSubject = this.ndgVariationList.find(subject => subject[this.dettaglioAnagraficoKey]['ns2:ndg'] === ndg.trim())?.[this.dettaglioAnagraficoKey];
            this.onSubjectSelection.emit(this.selectedSubject);
        })
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['ndgVariationList'] &&changes['ndgVariationList'].currentValue) {
            this.showEmptyListMessage = false;
            this.populateFormOptions();
        }
    }

    populateFormOptions(): void {
        if (this.formKeys && this.ndgVariationList) {
            const options: any[] = [];
            this.ndgVariationList.forEach((element: IAnagrafica) => {
                const dettaglioAnagrafico = element[this.dettaglioAnagraficoKey];
                const optionValue = {
                    key: dettaglioAnagrafico['ns2:ndg'],
                    value: dettaglioAnagrafico['ns2:naturaGiuridica'] ? 
                        dettaglioAnagrafico['ns2:ndg'] + ' - ' + dettaglioAnagrafico['ns2:nome'] + ' ' + dettaglioAnagrafico['ns2:cognome'] :
                        dettaglioAnagrafico['ns2:ndg']
                }
                options.push(optionValue);
            });
            this.formKeys.forEach(formKey => {
                if (formKey?.controlName === 'ndg') {
                    formKey.options = CommonUtils.assign(options);
                }
            })
        }
    }

    getFormattedDate(date: string) {
        const formattedDate = moment(date, 'YYYYMMDD').format(DATE_FORMAT_SLASH);
        if (moment(formattedDate).isValid()) {
            return formattedDate;
        }
        return date;
    }

    get policyId(): string {
        return this._policyService.policyId;
    }

    get subjectKeys(): IFormKey[] {
        return this.selectedSubject ? CommonUtils.assign(applicant_keys_PF) : [];
    }

    get subjectName(): string {
        return this.selectedSubject ? `${this.selectedSubject['ns2:nome']} ${this.selectedSubject['ns2:cognome']}` : '';
    }

    get isDocumentExpired(): boolean {
        const expiryDate = CommonUtils.checkAndGet(this.selectedSubject, 'ns2:datiDocumento.ns2:dataScadenza', null);
        return expiryDate ? moment(expiryDate, DATE_FORMAT).isBefore(moment()) : false;
    }

    get docExpiredWarnMessage(): string {
        return DOC_EXPIRED_MESSAGE;
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }

}